import React, { FC } from 'react'
import { LayoutProps } from '@sport1/types/web'
import Config from '@/utils/Config'
import { isCrawlerRegExp } from '@/utils/userAgent'

const SourcePoint: FC<{ layoutData?: LayoutProps; cmpIsActive: boolean }> = ({
    layoutData,
    cmpIsActive,
}) => {
    const cmpConfig = {
        config: {
            accountId: Config.SOURCE_POINT_ACCOUNT_ID,
            baseEndpoint: Config.SOURCE_POINT_BASE_ENDPOINT,
            campaignEnv: Config.SOURCE_POINT_CAMPAIGN_ENV,
            propertyHref: Config.SOURCE_POINT_PROPERTY_HREF,
            propertyId: Config.SOURCE_POINT_PROPERTY_ID,
            managerId: Config.SOURCE_POINT_PRIVACY_MANAGER_ID,
        },
    }

    const meta = layoutData?.meta as { consentNeeded?: boolean } | undefined

    if (!cmpConfig.config.propertyId) {
        return null
    }

    const loadingScript =
        !cmpIsActive || meta?.consentNeeded === false ? null : (
            <script
                async={true}
                id="SourcePointCMPScript"
                dangerouslySetInnerHTML={{
                    __html: `!${isCrawlerRegExp}.test(navigator.userAgent) && (window.Cypress == undefined) && document.write('<scr' + 'ipt async importance="high" src="${cmpConfig.config.baseEndpoint}/wrapperMessagingWithoutDetection.js"></scr' + 'ipt>')`,
                }}
            />
        )
    return (
        <>
            <link
                rel="preload"
                as="script"
                href={`${cmpConfig.config.baseEndpoint}/wrapperMessagingWithoutDetection.js`}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: `window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: "cmp_disclosure_only"});`,
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: `"use strict";function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(){var t=function(){var t,e,o=[],n=window,r=n;for(;r;){try{if(r.frames.__tcfapiLocator){t=r;break}}catch(t){}if(r===n.top)break;r=r.parent}t||(!function t(){var e=n.document,o=!!n.frames.__tcfapiLocator;if(!o)if(e.body){var r=e.createElement("iframe");r.style.cssText="display:none",r.name="__tcfapiLocator",e.body.appendChild(r)}else setTimeout(t,5);return!o}(),n.__tcfapi=function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];if(!n.length)return o;"setGdprApplies"===n[0]?n.length>3&&2===parseInt(n[1],10)&&"boolean"==typeof n[3]&&(e=n[3],"function"==typeof n[2]&&n[2]("set",!0)):"ping"===n[0]?"function"==typeof n[2]&&n[2]({gdprApplies:e,cmpLoaded:!1,cmpStatus:"stub"}):o.push(n)},n.addEventListener("message",(function(t){var e="string"==typeof t.data,o={};if(e)try{o=JSON.parse(t.data)}catch(t){}else o=t.data;var n="object"===_typeof(o)&&null!==o?o.__tcfapiCall:null;n&&window.__tcfapi(n.command,n.version,(function(o,r){var a={__tcfapiReturn:{returnValue:o,success:r,callId:n.callId}};t&&t.source&&t.source.postMessage&&t.source.postMessage(e?JSON.stringify(a):a,"*")}),n.parameter)}),!1))};"undefined"!=typeof module?module.exports=t:t()}();`,
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: `window._sp_ = ${JSON.stringify(cmpConfig)}`,
                }}
            />
            {loadingScript}
        </>
    )
}

export const openPrivacyManager = (): void => {
    if (typeof window !== 'undefined' && window._sp_?.config?.managerId) {
        if (window._sp_.loadPrivacyManagerModal) {
            /**
             * if loadPrivacyManagerModal is present, open right away
             */
            window._sp_.loadPrivacyManagerModal(window._sp_.config.managerId)
        } else if (window.SourcePointCMPScript) {
            /**
             * the script has been added, but loadPrivacyManagerModal
             * has yet to be provided (is not present right away on
             * script load)
             */
            setTimeout(openPrivacyManager, 100)
        } else {
            /**
             * load script and retry function
             */
            const script = document.createElement('script')
            script.id = 'SourcePointCMPScript'
            script.src = `${window._sp_.config.baseEndpoint}/wrapperMessagingWithoutDetection.js`
            script.addEventListener('load', openPrivacyManager)
            document.head.append(script)
        }
    }
}

export default SourcePoint
